import Vue from "vue";

Vue.component("dialect-dropdown", {
    props: ["readonly",
        "language",
        "model",
        "placeholder"
    ],
    data() {
        return {
            items: [],
            selected: this.model
        };
    },
    methods: {
        getDataSourceText: (dataSource, value) => {
            if (dataSource) {
                const item = dataSource.filter(item => item.value == value)[0];
                return !item ? "" : item.text;
            }
            return "";
        },
        getDialects: function () {
            this.$services.dialects.getForDropdown({
                language: this.language
            })
                .then((data) => {
                    let dialects = data.items;
                    data.items.forEach(function (item, index) {
                        switch (item.value) {
                            case "EN":
                                data.items.splice(index, 1);
                                dialects.splice(0, 0, item);
                                break;
                            case "FR":
                                data.items.splice(index, 1);
                                dialects.splice(1, 0, item);
                                break;
                            case "ES":
                                data.items.splice(index, 1);
                                dialects.splice(2, 0, item);
                                break;
                        }
                    })

                    this.items = dialects;
                });
        }
    },
    watch: {
        selected: function (val) {
            if (val != this.model)
                this.$emit("update:model", val);
        },
        model: function (val) {
            if (val != this.selected)
                this.selected = val;
        }
    },
    mounted: function () {

        this.getDialects();
    },

    template: `
	<b-select v-if="!readonly" v-model="selected" :disabled="readonly" expanded :placeholder="placeholder">
	    <option v-for="option in items"
			:value="option.value"
			:key="option.value">
		    {{ option.text }}
	    </option>
    </b-select>
    <div v-else class="input">{{ getDataSourceText(items, selected) }}</div>
	`
});